+function ($) {
	'use strict';

	// ELEVATE CLASS DEFINITION
	// =========================
	var Elevate = function () { };

	Elevate.VERSION = '1.0.0';

	///Specify a specific 'elevation' by setting data-elevation on the 
	///target el. The value corresponds to the number of pixels off of 
	///vertical center the target will move
	Elevate.DEFAULT_ELEVATION = 120;
	Elevate.MIN_SCREEN_WIDTH = 992;
	Elevate.TARGET_SELECTOR = ".elevate-target"
	Elevate.prototype.init = function ($target) {
		this.$target = $target;
		this._elevation = $target.data("elevation") || Elevate.DEFAULT_ELEVATION;
		this._position();
		$(window)
		  .on("resize.mk.elevate", $.proxy(this._position, this))
		  .on("scroll.mk.elevate", $.proxy(this._position, this));
	};
	Elevate.prototype._position = function () {

		var nTranslateY = 0;
		if (this._checkEnabled()) {
			//calculate distance of midpoint of target from viewports center
			//convert to percentage relative to height of viewport
			//move target by percentage * elevation
			var nTargetTop = this.$target.offset().top;
			var nTargetHeight = this.$target.height();
			var nScrollTop = window.scrollY;
			var nViewportHeight = $(window).height();
			var nViewportCenter = nScrollTop + (nViewportHeight / 2);
			var nTargetCenter = nTargetTop + (nTargetHeight / 2);
			var nVarianceFromCenter = nTargetCenter - nViewportCenter;
			var nRelativeOffset = nVarianceFromCenter / nViewportHeight;
			nTranslateY = (this._elevation * nRelativeOffset);
		} 
		this.$target.css("transform", "translateY(" + nTranslateY + "px)");
	};

	//Disable effect at mobile and tablet sizes
	Elevate.prototype._checkEnabled = function () {
		return $(window).width() >= Elevate.MIN_SCREEN_WIDTH;
	};

	$(Elevate.TARGET_SELECTOR).each(function () {
		var el = new Elevate();
		el.init($(this));
	})

}(jQuery);